export default function isDocument(element) {
  return 'nodeType' in element && element.nodeType === document.DOCUMENT_NODE;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-overlays/node_modules/dom-helpers/esm/isDocument.js
// module id = 356
// module chunks = 1